export default () => {

    const expanders = document.querySelectorAll('.expandContent');

    if (!expanders.length) {
        return;
    }

    const buttonHandler = (e) => {
        const {target} = e;
        const item = target.classList.contains('expandContent') ? target : target.closest('.expandContent');
        const {toexpand, parent, type = 'expand'} = item.dataset;

        if (!toexpand || !parent) {
            return;
        }

        const parentWrapper = item.closest(`.${parent}`);
        const toExpandWrapper = parentWrapper?.querySelector(`.${toexpand}`);

        if (!toExpandWrapper) {
            return;
        }

        typeHandler(type, toExpandWrapper, item);

    }

    const typeHandler = (type, target, button) => {
        switch(type) {
            case 'toggler':
                togglerHandler(target, button);
                break;
            default:
                expandHandler(target, button);
        } 
    }

    const togglerHandler = (target, button) => {
        target.classList.toggle('expanded');
        target.classList.toggle('collapsed');

        button.classList.toggle('toggler')
    }

    const expandHandler = (target, button) => {
        target.classList.remove('collapsed');
        target.classList.add('expanded');
        button.remove();
    }

    expanders.forEach(expander => expander.addEventListener('click', buttonHandler));
}
